import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronRight } from "@air/next-icons";
import { memo, useCallback } from "react";
import BoardThumbnail from "~/components/BoardThumbnail/BoardThumbnail";
import { BoardSuggestionBreadcrumbs } from "~/components/SearchBar/Suggestion/BoardSuggestionBreadcrumbs";
import { SearchCommandItem } from "~/components/SearchCommand/SearchCommandItem";
export const SearchCommandBoardListItem = /*#__PURE__*/ memo((param)=>{
    let { board, onSelect: _onSelect } = param;
    var _board_ancestors;
    const onSelect = useCallback(()=>_onSelect(board), [
        board,
        _onSelect
    ]);
    var _board_ancestors1;
    return /*#__PURE__*/ _jsxs(SearchCommandItem, {
        "data-type": "board",
        onSelect: onSelect,
        value: board.id,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "shrink-0 rounded border border-grey-5 bg-grey-1 p-1",
                children: /*#__PURE__*/ _jsx(BoardThumbnail, {
                    board: board,
                    sizes: "40px",
                    width: 72,
                    height: 40
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "grow px-1",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "truncate text-14 font-medium",
                        children: board.title
                    }),
                    !!((_board_ancestors = board.ancestors) === null || _board_ancestors === void 0 ? void 0 : _board_ancestors.length) ? /*#__PURE__*/ _jsx(BoardSuggestionBreadcrumbs, {
                        ancestors: (_board_ancestors1 = board.ancestors) !== null && _board_ancestors1 !== void 0 ? _board_ancestors1 : []
                    }) : null
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex size-8 shrink-0 items-center",
                children: /*#__PURE__*/ _jsx(ChevronRight, {
                    className: "w-4 text-grey-12"
                })
            })
        ]
    });
});
SearchCommandBoardListItem.displayName = "SearchCommandBoardListItem";
